const Testimonials = (() => {

	const DOM = {};

	const cacheDOM = () => {
		DOM.left   = document.querySelectorAll( '.testimonials__slide-button--prev' );
		DOM.right  = document.querySelectorAll( '.testimonials__slide-button--next' );
		DOM.dot    = document.querySelectorAll( '.testimonials__slider-dots--dot' );
		DOM.slider = document.querySelectorAll( '.testimonials__track' );
		DOM.slide  = document.querySelectorAll( '.testimonials__slide' );
		DOM.width  = DOM.slider[0].getBoundingClientRect().width;
	};

	const onLoad = () => {
		getHeight();
		slidePosition();
	};

	const getHeight = () => {
		let highest = 0;
		DOM.slide.forEach(
			function (slide){
				let slideHeight = slide.firstElementChild.getBoundingClientRect().height;
				highest         = slideHeight > highest ? slideHeight : highest;
			}
		);
		setHeight( highest );
	};

	const setHeight            = (height) => {
		let container          = DOM.slider[0].parentElement.parentElement;
		container.style.height = height + 130 + 'px';
	};

	const slidePosition = () => {
		let i           = 0;
		DOM.slide.forEach(
			function (slide){
				slide.style.left = DOM.width * i + 'px';
				i++;
			}
		);
	};

	const eventListeners = () => {
		DOM.right[0].addEventListener( 'click', nextSlide );
		DOM.left[0].addEventListener( 'click', prevSlide );
		DOM.dot.forEach(
			function (dot){
				dot.addEventListener(
					'click',
					function (){
						changeSlide( dot );
					}
				);
			}
		);
	};

	const nextSlide      = () => {
		let currentSlide = DOM.slider[0].getElementsByClassName( 'current-slide' );
		let nextSlide    = currentSlide[0].nextElementSibling;
		let currentDot   = DOM.dot[0].parentElement.getElementsByClassName( 'current-slide' );
		let nextValue    = nextSlide.getAttribute( 'data-value' ) - 1;
		let dot          = DOM.dot[nextValue];
		moveDot( currentDot[0], dot );
		moveSlide( currentSlide[0], nextSlide );
	};

	const prevSlide      = () => {
		let currentSlide = DOM.slider[0].getElementsByClassName( 'current-slide' );
		let nextSlide    = currentSlide[0].previousElementSibling;
		let currentDot   = DOM.dot[0].parentElement.getElementsByClassName( 'current-slide' );
		let nextValue    = nextSlide.getAttribute( 'data-value' ) - 1;
		let dot          = DOM.dot[nextValue];
		moveDot( currentDot[0], dot );
		moveSlide( currentSlide[0], nextSlide );
	};

	const changeSlide = (dot) => {
		if ( ! dot.classList.contains( 'current-slide' )) {
			let currentDot   = dot.parentElement.getElementsByClassName( 'current-slide' );
			let currentValue = currentDot[0].getAttribute( 'data-value' ) - 1;
			let nextValue    = dot.getAttribute( 'data-value' ) - 1;
			let currentSlide = DOM.slide[currentValue];
			let nextSlide    = DOM.slide[nextValue];
			moveDot( currentDot[0], dot );
			moveSlide( currentSlide, nextSlide );
		}
	}

	const moveDot = (currentDot, dot) => {
		currentDot.classList.remove( 'current-slide' );
		dot.classList.add( 'current-slide' );
	};

	const moveSlide = (currentSlide, nextSlide) => {
		DOM.slider[0].setAttribute( 'style', `transform: translateX( -${nextSlide.style.left} )` )
		currentSlide.classList.remove( 'current-slide' );
		nextSlide.classList.add( 'current-slide' );
		if ( ! nextSlide.nextElementSibling) {
			DOM.left[0].classList.remove( 'hidden' );
			DOM.right[0].classList.add( 'hidden' );
		} else if ( ! nextSlide.previousElementSibling) {
			DOM.right[0].classList.remove( 'hidden' );
			DOM.left[0].classList.add( 'hidden' );
		}
	}

	const init = () => {
		cacheDOM();
		onLoad();
		eventListeners();

	}

	return {
		init,
	}

})();

export default Testimonials;
